type tTaxesList = {
    id: string;
    total?: string;
    year: string;
    billed: string;
    ballance: string;
    interest: string;
    total_due: string;
    data: {
        id: string;
        due_date?: string;
        year: string;
        type?: string;
        billed: string;
        ballance: string;
        interest: string;
        total_due: string;
        status?: 'open' | 'paid';
        tx?: string;
        className?: string;
    }[];
};

export const taxesList: tTaxesList[] = [
    {
        id: '1',
        year: '2023',
        billed: '$6,659',
        ballance: '$6,659',
        interest: '$0.00',
        total_due: '$6,659',
        data: [
            {
                id: '1',
                due_date: '08/01/2023',
                year: '',
                type: 'Tax',
                billed: '$6,659',
                ballance: '$6,659',
                interest: '$0.00',
                total_due: '$6,659',
                status: 'open',
                tx: '0xdafea492d9c',
            },
            {
                id: '2',
                due_date: '05/01/2023',
                year: '',
                type: 'Tax',
                billed: '$6,659',
                ballance: '$0.00',
                interest: '$0.00',
                total_due: '$0.00',
                status: 'paid',
                tx: '0xdafea492d9c',
            },
            {
                id: '3',
                due_date: '02/01/2023',
                year: '',
                type: 'Tax',
                billed: '$6,659',
                ballance: '$0.00',
                interest: '$0.00',
                total_due: '$0.00',
                status: 'paid',
                tx: '0xdafea492d9c',
            },
        ],
    },
    {
        id: '2',
        year: '2022',
        billed: '$9,714.96',
        ballance: '$0.00',
        interest: '$0.00',
        total_due: '$0.00',
        data: [
            {
                id: '4',
                due_date: '11/01/2022',
                year: '',
                type: 'Tax',
                billed: '$9,714.96',
                ballance: '$0.00',
                interest: '$0.00',
                total_due: '$0.00',
                status: 'open',
                tx: '0xdafea492d9c',
            },
        ],
    },
];
